import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './components/Core/App.jsx'
import registerServiceWorker from './registerServiceWorker'

// framer-motion v10 uses useInsertionEffect (React 18+). Polyfill for React 16.
if (!React.useInsertionEffect)
	React.useInsertionEffect = React.useLayoutEffect

ReactDOM.render((
	<BrowserRouter>
		<App />
	</BrowserRouter>
), document.getElementById('root'))
registerServiceWorker()
